import { FC, ReactElement } from 'react';

export type TransTextProps = {
  i18nKey: string;
  replacements: Record<string, ReactElement>;
};

export type FormTitleType = TransTextProps | string;

type FormTitleProps = {
  title: FormTitleType;
};

export const TransText: FC<TransTextProps> = (props) => {
  const { i18nKey, replacements } = props;
  const keys = Object.keys(replacements)
    .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');

  const regex = new RegExp(`(${keys})`, 'g');
  const textSlices = i18nKey.split(regex);

  return (
    <>
      {textSlices.map((slice, index) => (
        <span key={index}>{replacements[slice] ? replacements[slice] : slice}</span>
      ))}
    </>
  );
};

export const FormTitle: FC<FormTitleProps> = (props) => {
  const { title } = props;
  const needTrans = typeof title !== 'string';
  return needTrans ? <TransText {...title} /> : <span>{title}</span>;
};
